import { bool, object, node, number } from "prop-types";
import { observer } from "mobx-react";
import { BudgetTrackingBreakdownRowGroup } from "./BudgetTrackingBreakdownRowGroup";

export const BudgetTrackingBreakdownRowGroupList = observer(({
  element,
  isLastGroupRow,
  tableDepth = 0,
  initialDepth = 0,
  ...elementProps
}) => {
  const { children: elementChildren } = element;

  return (
    <>
      {elementChildren?.map((child, i) => (
        <BudgetTrackingBreakdownRowGroup
          key={`element${child.id}`}
          element={child}
          isLastGroupRow={
            isLastGroupRow &&
            (tableDepth === 0 || i === elementChildren.length - 1)
          }
          tableDepth={tableDepth + 1}
          initialDepth={initialDepth}
          {...elementProps}
        />
      ))}
    </>
  );
});

BudgetTrackingBreakdownRowGroupList.propTypes = {
  element: object.isRequired,
  tableDepth: number,
  initialDepth: number,
  isLastGroupRow: bool,
  children: node,
};
